function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3 6.995a1 1 0 002 0H3zm2-5.99a1 1 0 00-2 0h2zM6.995 5a1 1 0 000-2v2zm-5.99-2a1 1 0 000 2V3zM5 6.995v-5.99H3v5.99h2zM6.995 3h-5.99v2h5.99V3z",
  fill: "currentColor"
});
function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    fill: "none"
  }, props), _ref);
}
export default SvgPlus;